export enum Theme {
  URGENCY = 'pwa-theme--urgency',
  SUCCESS = 'pwa-theme--success',
  LOYALTY = 'pwa-theme--loyalty',
  SUCCESS_MEDIUM = 'pwa-theme--success uitk-type-medium',
  LINK = 'pwa-theme--link',
  NONE = ''
}

export enum ThemeName {
  URGENT = 'URGENCY',
  SUCCESS = 'SUCCESS',
  LOYALTY = 'LOYALTY',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  LINK = 'LINK',
  BRANDED_DEAL = 'BRANDED_DEAL',
  NONE = 'NONE'
}
